(function ($) {

    $.fn.ref_menumaker = function (options) {

        var refOverlayMenu = $(this), settings = $.extend({
            title: "Resource Menu",
            format: "dropdown",
            sticky: false
        }, options);

        return this.each(function () {
            refOverlayMenu.prepend('<div id="menu-button">' + settings.title + '</div>');
            $(this).find("#menu-button").on('click', function () {
                $(this).toggleClass('menu-opened');
                var mainmenu = $(this).next('ul');
                if (mainmenu.hasClass('open')) {
                    mainmenu.hide().removeClass('open');
                }
                else {
                    mainmenu.show().addClass('open');
                    if (settings.format === "dropdown") {
                        mainmenu.find('ul').show();
                    }
                }
            });

            refOverlayMenu.find('li ul').parent().addClass('has-sub');

            multiTg = function () {
                refOverlayMenu.find(".has-sub").prepend('<span class="submenu-button"></span>');
                refOverlayMenu.find('.submenu-button').on('click', function () {
                    $(this).toggleClass('submenu-opened');
                    if ($(this).siblings('ul').hasClass('open')) {
                        $(this).siblings('ul').removeClass('open').hide();
                    }
                    else {
                        $(this).siblings('ul').addClass('open').show();
                    }
                });
            };

            if (settings.format === 'multitoggle') multiTg();
            else refOverlayMenu.addClass('dropdown');

            if (settings.sticky === true) refOverlayMenu.css('position', 'fixed');

            resizeFix = function () {
                if (window.innerWidth > 768) {
                    refOverlayMenu.find('ul').show();
                }

                if (window.innerWidth <= 768) {
                    refOverlayMenu.find('ul').hide().removeClass('open');
                }
            };
            resizeFix();
            return $(window).on('resize', resizeFix);

        });
    };
})(jQuery);

(function ($) {
    $(document).ready(function () {

        $("#refOverlayMenu").ref_menumaker({
            title: "Implant Logistics Resource Menu",
            format: "multitoggle"
        });

        // close mobile menu if clicked on any links for a better experience
        $('#refOverlayMenu a').on('click', function () {
            var onclick = $(this).attr('onclick');
            if (onclick) {
                $('#menu-button').click();
            }
        });

    });
})(jQuery);
function ref_overlaySize() {
    var h = window.innerHeight;
    document.getElementById("refIframe").style.height = (h * .9) + "px";
    //document.getElementById("refMenu").style.height= (h*.05)+"px";
}
function iframeSrc(newsrc) {
    var iframe = document.getElementById("refIframe");
    iframe.src = newsrc;
}
function ref_overlayOn() {
    ref_overlaySize();
    document.getElementById("refOverlay").style.display = "block";
}
function ref_overlayOff() {
    document.getElementById("refOverlay").style.display = "none";
}